import React from "react";
import { useEffect, useState, useRef } from "react";
import {
  Button,
  Popper,
  MenuList,
  Grow,
  ClickAwayListener,
  MenuItem,
  Paper,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { GetCourseOwners } from "../../../api/endpoints";
import apiClient from "../../../api/apiClient";

const CourseOwnerFilter = ({onSelectedOwnerChange}) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState([]);
  // const [selectedOwnerChanged, setSelectedOwnerChanged] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);


  // console.log('owner', selectedOwner)


  // ! Get All Course List
  //! Separating headers to get 200 status
  async function getAllCourseOwner() {
    setLoading(true);
    try {
      const response = await apiClient.post(GetCourseOwners, {},);
      setData(response.data.data);
      setDataFetched(true);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    async function fetchData() {
      await getAllCourseOwner();
    }
  
    fetchData();
  }, []);
  
  useEffect(() => {
    if (dataFetched) {
      if (selectedOwner.length === 0) {
        const allOwnerIds = data.map((owner) => owner.ownerAdminId);
        onSelectedOwnerChange(allOwnerIds);
      } else {
        onSelectedOwnerChange(selectedOwner);
      }
    }
  }, [selectedOwner, dataFetched]);
  


  const handleOwnerSelect = (ownerAdminId) => {
    if (selectedOwner.includes(ownerAdminId)) {
      setSelectedOwner(
        selectedOwner.filter((id) => id !== ownerAdminId)
      );
    } else {
      setSelectedOwner([...selectedOwner, ownerAdminId]);
    }
  };
  
  const handleOwnerSelectAll = () => {
    const allOwners = data.map((item) => item.ownerAdminId);
    setSelectedOwner(allOwners);
  };  

  const handleOwnerClearAll = () => {
    setSelectedOwner([]);
  };

  // ! Button Functions

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event?.target)) {
      return;
    }
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  return (
    <>
      <Button
        // variant="outlined"
        className="FilterButton"
        endIcon={<ExpandMoreIcon />}
        ref={anchorRef}
        id="composition-button"
        aria-controls={open ? "composition-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
        sx={{
          mx: 3,
          px: 2,
          "@media (max-width: 600px)": {
            mx: 1,
            px: 1,
          },
          "@media (max-width: 400px)": {
            mx: 0,
            px: 0,
          },
          // Truncate text and add ellipsis when it overflows
          maxWidth: "150px",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        Kursansvarlig
      </Button>
      <Popper
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
        sx={{ zIndex: "tooltip" }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={open}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem
                    key="select-all"
                    onClick={handleOwnerSelectAll}
                  >
                    Velg alle
                  </MenuItem>
                  {data?.map((item, i) => (
                   <MenuItem
                   key={i}
                   onClick={() => handleOwnerSelect(item.ownerAdminId)}
                   selected={selectedOwner.includes(item.ownerAdminId)}
                 >
                   {item.nameSurname}
                 </MenuItem>
                 
                  
                  ))}
                  <MenuItem key="clear-all" onClick={handleOwnerClearAll}>
                    <ClearIcon
                      fontSize="small"
                      sx={{ color: "#858585", marginRight: 1 }}
                    />
                    Fjern alle
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default CourseOwnerFilter;
